/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { useContext } from 'react';
import { ButtonGhost } from '@uberall/zenit';

import styles from './select-account-section.module.css';
import sharedStyles from '../../../sharedStyles.module.css';
import Message from '../../Message';
import { RequestAccessFormContext } from '../../../contexts/request-access-form-context';
import { useFetchRequestAccessForm } from '../../../api/hooks/useFetchRequestAccessForm';

const SelectAccountSection = () => {
    const { userEmail, setStep } = useContext(RequestAccessFormContext);
    const { data } = useFetchRequestAccessForm();

    const handleSignInAgain = () => {
        setStep(1);
    };
    return (
        <section className={styles.selectAccountSection}>
            <h1 className={sharedStyles.textHeadline}>
                <Message code="app.request.access.public.step.2.select.google.account" />
            </h1>
            <div>
                <Message
                    className={sharedStyles.textBold}
                    code="app.request.access.public.step.2.select.google.account.signed.in.as"
                />{' '}
                {userEmail}
            </div>
            <div>
                <Message code="app.request.access.public.step.2.select.google.account.wrong.account" />{' '}
                <ButtonGhost
                    hasLinkStyles
                    onClick={handleSignInAgain}
                    sx={{ color: data?.counterBackgroundColor }}
                >
                    <Message code="app.request.access.public.step.2.select.google.account.sign.in.again" />
                </ButtonGhost>
            </div>
        </section>
    );
};

export default SelectAccountSection;
